import { render, staticRenderFns } from "./TodoDialog.vue?vue&type=template&id=20cb7ac8"
import script from "./TodoDialog.vue?vue&type=script&lang=js"
export * from "./TodoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports